export default "__VITE_ASSET__DPzZn1cT__"